import { Box, Slider, Typography } from '@mui/material';
import React, { useEffect } from 'react';

const skillLevelMapping = ['Da zero', 'Principiante', 'Intermedio', 'Avanzato'];

interface LevelSliderProps {
  className?: string;
  onChange?: (selectedLevels: string[] | null) => void;
  selectedLevels?: string[]; // New prop to set initial slider position
  disabled?: boolean; // Add disabled prop
}

export const LevelSlider = ({
  className,
  onChange,
  selectedLevels,
  disabled = false,
}: LevelSliderProps) => {
  const [range, setRange] = React.useState<[number, number]>([0, 3]);

  // Update the slider range based on current filters when component mounts or filters change
  useEffect(() => {
    if (selectedLevels && selectedLevels.length > 0) {
      // Find the min and max indexes from the mapping based on selectedLevels
      const minIndex = skillLevelMapping.findIndex((l) => l === selectedLevels[0]);
      const maxIndex = skillLevelMapping.findIndex(
        (l) => l === selectedLevels[selectedLevels.length - 1],
      );
      // If for some reason the levels are not found, default to full range
      setRange([minIndex >= 0 ? minIndex : 0, maxIndex >= 0 ? maxIndex : 3]);
    } else {
      // No skill level filter means full range selected
      setRange([0, 3]);
    }
  }, [selectedLevels]);

  const handleChange = (_: Event, newValue: number | number[]) => {
    if (disabled) return;

    const val = newValue as [number, number];
    setRange(val);

    const [minVal, maxVal] = val;
    if (minVal === 0 && maxVal === 3 && onChange) {
      // All selected, means no filter
      onChange(null);
    } else if (onChange) {
      // Return a subset of levels
      const selected = skillLevelMapping.slice(minVal, maxVal + 1);
      onChange(selected);
    }
  };

  return (
    <div className={`flex flex-col w-full ${className}`}>
      <Typography variant="s1" component="p" className="mb-2">
        Livello
      </Typography>
      <div className="w-full px-1">
        <Slider
          orientation="horizontal"
          size="medium"
          color="primary"
          value={range}
          onChange={handleChange}
          step={1}
          min={0}
          max={3}
          valueLabelDisplay="off"
          disabled={disabled}
        />
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <img
            src="/assets/images/catalog/levels/mai-suonato.png"
            className="h-[18px]"
            alt="Da zero"
          />
          <img
            src="/assets/images/catalog/levels/base.png"
            className="h-[18px]"
            alt="Principiante"
          />
          <img
            src="/assets/images/catalog/levels/intermedio.png"
            className="h-[18px]"
            alt="Intermedio"
          />
          <img
            src="/assets/images/catalog/levels/avanzato.png"
            className="h-[18px]"
            alt="Avanzato"
          />
        </Box>
      </div>
    </div>
  );
};
